import { createContext } from 'react';
import { WebSocketHook } from 'react-use-websocket/dist/lib/types';

import { IComponent } from '../../shared/interfaces/IComponent';

export type IWebsocketContext = Pick<
  WebSocketHook,
  'lastMessage' | 'lastJsonMessage' | 'readyState'
> & {
  useRegisterCallback: (
    eventType: WebsocketEventType,
    callback: (message: IWebsocketMessage) => void,
  ) => void;
};

export enum WebsocketEventType {
  NewNotification = 'new_notification',
  RequestPCF = 'request_pcf',
  RequestBulkPcfSingleCompleted = 'request_bulk_pcf',
  RequestBulkPcfSummary = 'request_bulk_pcf_summary',
  ImportFile = 'import_file',
  CalculationPdfGenerated = 'calculation_pdf_generated',
  RequestUpdated = 'request_updated',
  CertificateExchange = 'certificate_exchange',
}

export type DetailErrorMessages = { row: number; message: string };

export enum ModuleType {
  ALL_REQUESTS = 'all_requests',
  COMPANIES = 'companies',
  COMPONENTS = 'components',
  PRODUCTS = 'products',
  USERS = 'users',
  REQUEST = 'request',
  PULL_CERTIFICATES = 'pull_certificates',
  PUSH_CERTIFICATES = 'push_certificates',
  REVIEW_CERTIFICATES = 'review_certificates',
  REQUEST_CERTIFICATE = 'request_certificate',
  IMPORT_PRODUCTS = 'import_products',
  ASSIGN_PRODUCTS = 'assign_products',
  IMPORT_PRODUCTS_AND_PCFS = 'import_products_and_pcfs',
}

export interface IWebsocketMessage {
  user_id: number;
  eventType: WebsocketEventType;
  success?: boolean;
  message?: string;
  error?: string;
  componentName?: string;
  supplierCompanyName?: string;
  type?: ModuleType;

  // When eventType is request_updated
  failedCompanies?: string[];
  certificateId?: number;
  status?: string;

  // When eventType is request_bulk_pcf_summary (summary of bulk pcf)
  failureCount?: number;
  successCount?: number;

  // When eventType is request_bulk_pcf (result of an individual component in bulk pcf)
  component?: IComponent;

  detailErrorMessages?: DetailErrorMessages[];

  footprintId?: number;

  errorReportUrl?: string;
  errorRows?: number;

  // Certificate exchange specific fields
  detailErrorMessage?: string;
  receiverCompanyName?: string;
  receiverCompanyBpn?: string;
  certificateType?: string;
}

const WebsocketContext = createContext({} as IWebsocketContext);

export default WebsocketContext;
